/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTenantRequest
 */
export interface UpdateTenantRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTenantRequest
     */
    tenantId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    displayName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    owner: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    siteUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    state: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    currency: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    timeZone: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantRequest
     */
    taxRate: number;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateTenantRequest
     */
    principalLocationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantRequest
     */
    autoPaymentEnabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantRequest
     */
    autoTuitionCalculationEnabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantRequest
     */
    allowChargingFromInvoices: boolean | null;
}

/**
 * Check if a given object implements the UpdateTenantRequest interface.
 */
export function instanceOfUpdateTenantRequest(value: object): value is UpdateTenantRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('siteUrl' in value) || value['siteUrl'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('principalLocationId' in value) || value['principalLocationId'] === undefined) return false;
    if (!('autoPaymentEnabled' in value) || value['autoPaymentEnabled'] === undefined) return false;
    if (!('autoTuitionCalculationEnabled' in value) || value['autoTuitionCalculationEnabled'] === undefined) return false;
    if (!('allowChargingFromInvoices' in value) || value['allowChargingFromInvoices'] === undefined) return false;
    return true;
}

export function UpdateTenantRequestFromJSON(json: any): UpdateTenantRequest {
    return UpdateTenantRequestFromJSONTyped(json, false);
}

export function UpdateTenantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTenantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'name': json['name'],
        'displayName': json['displayName'],
        'owner': json['owner'],
        'siteUrl': json['siteUrl'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'country': json['country'],
        'state': json['state'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'currency': json['currency'],
        'timeZone': json['timeZone'],
        'taxRate': json['taxRate'],
        'principalLocationId': ActorActivityRecordActorUserIdFromJSON(json['principalLocationId']),
        'autoPaymentEnabled': json['autoPaymentEnabled'],
        'autoTuitionCalculationEnabled': json['autoTuitionCalculationEnabled'],
        'allowChargingFromInvoices': json['allowChargingFromInvoices'],
    };
}

export function UpdateTenantRequestToJSON(json: any): UpdateTenantRequest {
    return UpdateTenantRequestToJSONTyped(json, false);
}

export function UpdateTenantRequestToJSONTyped(value?: UpdateTenantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'name': value['name'],
        'displayName': value['displayName'],
        'owner': value['owner'],
        'siteUrl': value['siteUrl'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'currency': value['currency'],
        'timeZone': value['timeZone'],
        'taxRate': value['taxRate'],
        'principalLocationId': ActorActivityRecordActorUserIdToJSON(value['principalLocationId']),
        'autoPaymentEnabled': value['autoPaymentEnabled'],
        'autoTuitionCalculationEnabled': value['autoTuitionCalculationEnabled'],
        'allowChargingFromInvoices': value['allowChargingFromInvoices'],
    };
}

